export default function isPreventField(path, prevent) {
  function action(context) {
    let state = context.state
    state.merge(path, { hidden: prevent })
  }
  return action
}



// WEBPACK FOOTER //
// ./src/modules/user/factories/isPreventField.js